import { Box } from '@rsos/base-components';
import NoShownResponses from './NoShownResponses';
import ShownResponses, { ShownResponsesInterface } from './ShownResponses';

interface SuggestedResponsesInterface extends ShownResponsesInterface {
  isShowResponses?: boolean;
}

/**
 * Returns a horizontal list of suggested responses.
 * Fixed height and width as the expected max character count per
 */
const SuggestedResponses = ({
  responses = [],
  handleViewClick = () => null,
  handleResponseClick = () => null,
  isShowResponses = false,
}: SuggestedResponsesInterface) => {
  return (
    <Box width="100%" backgroundColor="background" padding="8px 16px 16px">
      {isShowResponses ? (
        <ShownResponses
          responses={responses}
          handleViewClick={handleViewClick}
          handleResponseClick={handleResponseClick}
        />
      ) : (
        <NoShownResponses handleViewClick={handleViewClick} />
      )}
    </Box>
  );
};

export default SuggestedResponses;
